import { render, staticRenderFns } from "./AnnotationRecordGridItem.vue.js?vue&type=template&id=99e3b8ac!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AnnotationRecordGridItem.vue?vue&type=template&id=99e3b8ac"
import script from "./AnnotationRecordGridItem.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AnnotationRecordGridItem.vue?vue&type=script&lang=js"
export * from "./AnnotationRecordGridItem.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AnnotationRecordGridItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports